import * as React from 'react';
import { ReactNode, useContext } from 'react';
import { IntlShape, useIntl } from 'react-intl';
import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import { ToastContext, ToastContextType } from '../../../util/providers/ToastProvider';

interface Props {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  data: { key: string; name?: string };
}

const widgetUrl: string = process.env.REACT_APP_EMBED_WIDGET_URL ? process.env.REACT_APP_EMBED_WIDGET_URL : 'https://bibliographie-test.ub.rub.de/static/js/publig.js';


export const EmbeddingDialog = (props: Props): ReactNode => {
  const intl: IntlShape = useIntl();
  const toast: ToastContextType = useContext(ToastContext);
  if (!props.data) return <></>;
  const code: string = `<div data-ub-widget-id="${props.data.key}"></div>
<script src="${widgetUrl}"></script>`;

  return <Dialog header={intl.formatMessage({id: 'copy-clipboard.title'})}
                 visible={props.visible}
                 style={{width: '100%', maxWidth: '1000px'}}
                 closeOnEscape={true}
                 dismissableMask={true}
                 onHide={(): void => props.setVisible(false)}>
    <div className={'m-0 flex flex-column gap-4'}>
      <p>{`${props.data.name || intl.formatMessage({id: 'publist.unnamedPublist'})} (${props.data.key})`}</p>
      <InputTextarea value={code} disabled={false} readOnly={true} rows={5}/>
      <Button
        icon={'pi pi-clipboard'}
        label={intl.formatMessage({id: 'copy-clipboard.label'})}
        onClick={(): Promise<void> =>
          navigator.clipboard.writeText(code)
            .then((): void => {
              toast.notify({
                summary: intl.formatMessage({id: 'copy-clipboard.confirm'}),
                severity: 'info',
              });
            })
        }
      />
    </div>
  </Dialog>;
};
